import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import * as Icons from "../Icons";

export const RootDialog = styled(Dialog)(({ theme }) =>
    theme.unstable_sx({
        "& .MuiDialog-paper": {
            width: { md: "1000px" },
            maxWidth: "100%",
            height: "90dvh",
            maxHeight: { md: "700px" },
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            m: 0,
            borderRadius: { xs: 0, md: "16px" },
        },
    }),
);

export const HeaderStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        zIndex: 1,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        backgroundColor: "white.main",
        flexShrink: 0,
    }),
);

export const HeaderRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        position: "relative",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        minHeight: "64px",
        px: 4,
    }),
);

export const HeaderActionButton = styled(ButtonBase, {
    shouldForwardProp: (prop) => prop !== "$visible",
})<{ $visible: boolean }>(({ theme, $visible }) =>
    theme.unstable_sx({
        visibility: $visible ? "visible" : "hidden",
        p: 1,
        borderRadius: 1,
    }),
);

export const BackIcon = styled(Icons.Back)(({ theme }) =>
    theme.unstable_sx({
        width: "2.1rem",
        height: "2.1rem",
    }),
);

export const CloseIcon = styled(Icons.Close)(({ theme }) =>
    theme.unstable_sx({
        width: "2rem",
        height: "2rem",
    }),
);

export const StepsWrapper = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        pb: 3,
        px: 4,
    }),
);

export const ContentArea = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        overflowY: "auto",
        py: 7,
        px: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    }),
);

export const ContentInner = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
        maxWidth: "700px",
    }),
);

export const FooterContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        zIndex: 1300,
        bottom: 0,
        width: "100%",
        p: 4,
        boxShadow: "0 -4px 16px rgba(0,0,0,0.12)",
        backgroundColor: "white.main",
        flexShrink: 0,
    }),
);

export const ConfirmDialogTitle = styled(DialogTitle)(({ theme }) =>
    theme.unstable_sx({
        fontSize: "16px",
        fontWeight: 700,
        textAlign: "center",
    }),
);

export const ConfirmDialogContent = styled(DialogContent)(({ theme }) =>
    theme.unstable_sx({
        textAlign: "center",
    }),
);
